import { useQuery } from "@tanstack/react-query";
import { fetchAuthSites } from "@/app/_services/Auth/api";

export function useAuthSites() {
  return useQuery({
    queryKey: ["auth", "sites"],
    queryFn: fetchAuthSites,
  });
}
